import { lazy, useEffect } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";
import AccessibleNavigationAnnouncer from "./components/vendors/AccessibleNavigationAnnouncer";
import "./i18n/config";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import { checkAuth } from "./store/auth/authAction";
import ThemedSuspense from "./components/vendors/ThemedSuspense";
import { useTranslation } from "react-i18next";
import axios from "./axios/vendors/auth.axios";
import { useToasts } from "react-toast-notifications";
import { setGlobalErrorHandler } from "./utils/set-global-error-handler";
import { setTenantLogoHash } from "./store/global/globalSlice";
import { setGlobalLoadingHandler } from "./utils/set-global-loading-handler";
import { setPageTitle, setTenantLogo, setTenantName } from "./store/global/globalSlice";
import { initializeLanguage } from "./utils/ChangeLanguage";
import AuthRoute from "./routes/authRoute";

const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/vendors/Login"));
const ForgotPassword = lazy(() => import("./pages/vendors/forget-password/forget-password")); 
const RegisterTenant = lazy(() => import("./pages/tenant/register-tenant"));

function App() {
    const { t, i18n } = useTranslation();
    const { addToast } = useToasts();
    const isAuth = useAppSelector((state) => state.auth.isAuth);
    const { pageTitle, tenantName, tenantLogo, tenantLogoHash } = useAppSelector((state) => state.global);
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(checkAuth());
        setGlobalLoadingHandler(dispatch, [axios]);
        initializeLanguage()
        setGlobalErrorHandler(addToast, [axios], t, dispatch);
    }, []);

    useEffect(() => {
            if (pageTitle) {
                document.title = pageTitle;
            } else {
                document.title = "Pinvest CMS";
            }
    }, [pageTitle]);

    useEffect(() => {
      axios.get("/settings/public/panel").then(resp => {
          if(resp.data.pageTitle) dispatch(setPageTitle(resp.data.pageTitle));
          if(resp.data.tenantName) dispatch(setTenantName(resp.data.tenantName));
          if(resp.data.tenantLogo) dispatch(setTenantLogoHash(resp.data.tenantLogo));
      }).catch(e => {
      })

 
        const logoUrl = `${axios.defaults.baseURL}/settings/public/panel/image`;
        dispatch(setTenantLogo(logoUrl));
    }, []);

    useEffect(() => {
        const favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
        if (favicon) {
            favicon.href = tenantLogoHash ? tenantLogo : "/logo.png";
        } else {
            const link = document.createElement('link');
            link.type = 'image/x-icon';
            link.rel = 'shortcut icon';
            link.href = tenantLogoHash ? tenantLogo : "/logo.png";
            document.getElementsByTagName('head')[0].appendChild(link);
        }
    }, [tenantLogoHash]);

    let routes;
    if (isAuth === 2) {
        routes = (
            <>
                <Route path="/" component={Layout} />
            </>
        );
    } else if (isAuth === 1) {
        routes = (
            <>
                <AuthRoute path="/login" component={Login} />
                <AuthRoute path="/register-tenant" component={RegisterTenant} />
                <AuthRoute path="/forgot-password" component={ForgotPassword} />
                <Redirect exact to="/login" />
            </>
        )
    } else {
        routes = (<ThemedSuspense />)
    }
    return (
        <>
            <Router basename="/">
                <AccessibleNavigationAnnouncer />
                <Switch>
                    {routes}
                </Switch>
            </Router>
        </>
    );
}

export default App;
